// extracted by mini-css-extract-plugin
module.exports = {"bar":"ImageTopBar_bar__2kIgE"};